import React from 'react';

interface AuthorCardProps {
    author: {
        authorId: number;
        authorName: string;
        profilePhoto: string;
        authorEmail: string;
        keyword1?: string;
        keyword2?: string;
        introduce?: string;
        writingGenre?: string;
        bookId?: number;
        bookTitle?: string;
        bookGenre1?: string;
        bookGenre2?: string;
        bookOtherCount?: number;
    };
    onClick?: (author: any) => void;
}

const AuthorCard: React.FC<AuthorCardProps> = ({ author, onClick }) => {
    return (
        <div
            className="bg-white border border-[#f0f0f0] rounded-[17px] p-4 flex flex-col items-center gap-2.5 cursor-pointer hover:border-[#baecd4] hover:shadow-[0px_4px_16px_rgba(25,207,122,0.1)] transition-all duration-200"
            onClick={() => onClick?.(author)}
        >
            {/* 프로필 사진 */}
            <div className="w-[89px] h-[89px] md:w-[70px] md:h-[70px] rounded-full overflow-hidden shadow-[0px_4px_12px_rgba(25,207,122,0.15)] flex-shrink-0 mt-1">
                <img
                    src={
                        author.profilePhoto
                            ? `data:image/png;base64,${author.profilePhoto}`
                            : `${process.env.PUBLIC_URL}/img/profile_sam.jpg`
                    }
                    alt={author.authorName}
                    className="w-full h-full object-cover"
                />
            </div>

            {/* 이름 */}
            <span className="text-[#333] text-[15px] md:text-[13px] font-bold text-center line-clamp-1 mt-0.5">
                {author.authorName}
            </span>

            {/* 장르 및 키워드 태그 */}
            {(author.keyword1 || author.keyword2 || author.writingGenre || author.bookGenre1 || author.bookGenre2) && (
                <div className="flex flex-wrap gap-1 justify-center">
                    {(author.writingGenre || author.bookGenre1 || author.bookGenre2) && (
                        <span className="bg-[#e8f8f0] text-[#19cf7a] text-[11px] font-bold px-2 py-0.5 rounded-[6px]">
                            {author.writingGenre || author.bookGenre1 || author.bookGenre2}
                        </span>
                    )}
                    {author.keyword1 && (
                        <span className="bg-[#f8f9fa] text-[#555] text-[11px] font-medium px-2 py-0.5 rounded-[6px]">
                            #{author.keyword1}
                        </span>
                    )}
                    {author.keyword2 && (
                        <span className="bg-[#f8f9fa] text-[#555] text-[11px] font-medium px-2 py-0.5 rounded-[6px]">
                            #{author.keyword2}
                        </span>
                    )}
                </div>
            )}

            {/* 소개 */}
            {author.introduce && (
                <p className="text-[#7a7a7a] text-[11px] text-center line-clamp-2 leading-relaxed px-1">
                    {author.introduce}
                </p>
            )}

            {/* 최신 작품 정보 */}
            {author.bookTitle ? (
                <div className="mt-2 w-full pt-2 border-t border-[#f5f5f5] flex flex-col items-center">
                    <span className="text-[10px] text-[#aaa] font-medium mb-0.5">대표작</span>
                    <span className="text-[12px] text-[#333] font-bold truncate max-w-full text-center hover:text-[#19cf7a] transition-colors">
                        {author.bookTitle}
                        {author.bookOtherCount && author.bookOtherCount > 0 ? (
                            <span className="text-[11px] text-[#888] font-normal ml-1">
                                외 {author.bookOtherCount}권
                            </span>
                        ) : null}
                    </span>
                </div>
            ) : (
                <div className="mt-2 w-full pt-2 border-t border-[#f5f5f5] flex flex-col items-center">
                    <span className="text-[10px] text-[#ccc] italic">등록된 도서 없음</span>
                </div>
            )}
        </div>
    );
};

export default AuthorCard;
